import React from 'react';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <p className="footer-status">Currently at Nextiva. Open to conversations.</p>
      </div>
    </footer>
  );
}

export default Footer;
